/* global */
/**
 * Klaviyo documentation gate.
 * Each [data-doc-gate] holds a Klaviyo embed form and a hidden list of files
 * (from the pagina_fabricante metaobject). On successful Klaviyo form submit,
 * reveal the list so each file can be downloaded with its own button.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'fsDocGateUnlocked';

  function unlockedForms() {
    try {
      var list = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function rememberUnlock(formId) {
    try {
      var list = unlockedForms();
      if (list.indexOf(formId) === -1) list.push(formId);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable: list still shows for this page view */
    }
  }

  function reveal(gate) {
    var list = gate.querySelector('[data-doc-fallback]');
    if (list) list.hidden = false;
    gate.setAttribute('data-doc-state', 'done');
  }

  function triggerDownload(blob, fileName) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  // The `download` attribute is ignored on cross-origin (CDN) links, so fetch
  // the file as a blob to force a download; open it in a new tab if that fails.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-doc-download]');
    if (!link) return;
    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');

    var url = link.href;
    var name = link.getAttribute('data-file-name') || url.split('/').pop().split('?')[0];
    fetch(url, { mode: 'cors' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        triggerDownload(blob, name);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      })
      .then(function () {
        link.removeAttribute('aria-busy');
      });
  });

  function gatesForForm(formId) {
    if (!formId) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-doc-gate][data-klaviyo-form-id="' + formId + '"]')
    );
  }

  // Klaviyo dispatches `klaviyoForms` events on document.
  document.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.type !== 'submit') return;
    var gates = gatesForForm(e.detail.formId);
    if (!gates.length) return;
    rememberUnlock(e.detail.formId);
    gates.forEach(reveal);
  });

  // Already submitted in this session (e.g. Klaviyo reloaded the page).
  function restore() {
    unlockedForms().forEach(function (formId) {
      gatesForForm(formId).forEach(reveal);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
